<template>
  <div class="options-content">
    <OptionElements />
    <CSSElements />
    <ScriptsElements />
  </div>
</template>

<script>
import OptionElements from '@/widgets/controls/OptionElements.vue'
import CSSElements from '@/widgets/controls/CSSElements.vue'
import ScriptsElements from '@/widgets/controls/ScriptsElements.vue'

export default {
  name: 'OptionsList',
  components: {
    OptionElements,
    CSSElements,
    ScriptsElements
  },
}
</script>
